import React, { useEffect, useState } from 'react';
import Pricing from './Pricing/Pricing';
import RoataPricingCTA from './Pricing/RoataPricingCTA';
import Footer from './Footer/Footer';
import FAQ from './FAQ/FAQ';

const getIsDarkMode = () => document.documentElement.getAttribute('data-theme') === 'dark';

const PricingRoute = () => {
  const [dark, setDark] = useState(getIsDarkMode());

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDark(getIsDarkMode());
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section
        style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: dark ? '#18181b' : '#fafbfc',
          color: dark ? '#fff' : '#18181b',
          padding: '240px 0 130px 0',
          transition: 'background 0.3s, color 0.3s',
        }}
      >
        <h1
          style={{
            fontSize: '2.5rem',
            fontWeight: 600,
            color: dark ? '#fff' : '#18181b',
            textAlign: 'center',
            marginBottom: 16,
            transition: 'color 0.3s',
          }}
        >
          Flexible and transparent packages for all
        </h1>
        <p
          style={{
            fontSize: '1.1rem',
            color: dark ? '#cbd5e1' : '#64748b',
            textAlign: 'center',
            marginBottom: 32,
            transition: 'color 0.3s',
          }}
        >
          packages designed for every kind of user
        </p>
        <form
          style={{
            display: 'flex',
            gap: 12,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: 420,
            width: '100%',
          }}
          onSubmit={e => e.preventDefault()}
        >
          <input
            type="email"
            placeholder="E-mail address"
            style={{
              padding: '12px 20px',
              borderRadius: 8,
              border: 'none',
              background: dark ? '#23232a' : '#e5e7eb',
              color: dark ? '#fff' : '#18181b',
              fontSize: '1rem',
              width: 300,
              outline: 'none',
              marginRight: 8,
              transition: 'background 0.3s, color 0.3s',
            }}
          />
          <button
            type="submit"
            style={{
              padding: '12px 28px',
              borderRadius: 8,
              border: 'none',
              background: '#0098d0',
              color: '#fff',
              fontWeight: 600,
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >
            Book a Demo
          </button>
        </form>
      </section>
      <Pricing />
      <RoataPricingCTA />
      <FAQ />
      <Footer />
    </>
  );
};

export default PricingRoute; 